import VueApp from "../../03-fragments/vueApp/VueApp.js";

const processor = function(data) {
    return data;
}

const callback = function() {
    const target = document.querySelector("html");

    if (target.dataset.vueApps && parseInt(target.dataset.vueApps) > 0) {
        target.dataset.vueApps = target.dataset.vueApps - 1;
    }
}

VueApp.init({
    id: "teaserSection",
    processor: processor,
    callback: callback,
    settings: {
        customType: "project-story",
        title: "Neuigkeiten",
        root: "/neuigkeiten",
        batchCount: 4,
    },
    data: {
    },
});
